import { render, staticRenderFns } from "./FulfillmentModal.vue?vue&type=template&id=72090fc0&scoped=true"
import script from "./FulfillmentModal.vue?vue&type=script&lang=js"
export * from "./FulfillmentModal.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentModal.vue?vue&type=style&index=0&id=72090fc0&prod&lang=scss&scoped=true"
import style1 from "./FulfillmentModal.vue?vue&type=style&index=1&id=72090fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72090fc0",
  null
  
)

export default component.exports